var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"button__radio-label_container"},[_c('input',{staticClass:"button__radio-input radio-input",attrs:{"type":"radio"},domProps:{"checked":_vm.checked,"value":_vm.text}}),_c('RadioBorder'),(_vm.text)?_c('span',{staticClass:"button__radio-label choice",domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71118213","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChoiceButton.vue
// module id = null
// module chunks = 